import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { saveAs } from "file-saver";
import { useNavigate } from 'react-router-dom'
import cssclass from "./cssclass";
//var dateFormat = require('dateformat');



const RenderFileUploadBar = () => {
const navigate = useNavigate();

const resturl=sessionStorage.getItem("RESTURL");
const scansurl=sessionStorage.getItem("SCANSURL")??resturl;


const ELEMENT_PROGRESS = 'progresspiechart';
const FILUP_PIE_COLOR_PASSED = '#739bd0';//orange
const FILUP_PIE_COLOR_LEFT = '#b9e7ff';//lightgrey
const TEST_PERIOD = 60 * 1000;

/*
C:\\Users\\Dell\\Documents\\NEW MONSERATT BLUETOOTH BARCODE SCANNER 2CONNET.pdf
D:\\app\\Administrator\\admin\\orcl\\dpdump\\EXPORT_AWLIGHT_DAY01.DMP
*/

const [fileinput, setFileinput] = useState({
path:"D:\\app\\Administrator\\admin\\orcl\\dpdump\\EXPORT_BFADM_DAY22.DMP"
});


const [progress, setProgress] = useState({
perct:null
});

const [selectedFiles, setSelectedFiles] = useState([]);


const [axiofl, setAxiofl] = useState({
selectedFile: null
});








const location = useLocation();


useEffect(() => {
/*
*/

document.title =   "File Upload Bar";	

const username=sessionStorage.getItem("USERNAME")??"";

if (username!="ajones"){
	navigate("/");
	return;
	}//end if

document.getElementById("filepath").focus();


//updateProgress();
//setInterval("updateProgress()", 1000);

 },[]);


useEffect(() => {

	console.log("selectedFiles.length: "+selectedFiles.length);
	

 },[selectedFiles.length]);


useEffect(() => {

if (!progress.perct)
	return;

if (progress.perct>0){
	console.log("progress.perct: "+progress.perct);
	updateProgressElement(progress.perct);
	}
	

 },[progress.perct]);



function updateProgressElement(percentage) {
	document.getElementById("percentage").innerHTML="Pie Test: "+Math.round(percentage,0)+"%";
  document.getElementById(ELEMENT_PROGRESS).style.background="conic-gradient(" + FILUP_PIE_COLOR_PASSED + " 0, "  + FILUP_PIE_COLOR_PASSED + " " + percentage + "%, "  + FILUP_PIE_COLOR_LEFT + " 0)";
}

function updateProgressOld() {
  let testPercentage = ((Math.ceil(Date.now() % TEST_PERIOD)) / TEST_PERIOD) * 100;
  updateProgressElement(testPercentage);
}

async function uploadfiles(e){
	console.log('uploadfiles: '+selectedFiles.length);
	
//setAxiofl({ selectedFile: event.target.files });	
	//event.target.files
/*
ensure the below line in node js has the correct array size of 3 
router.post('/uploadfiles', upload.array('filesupload',3), (req, res, next) => {
*/	
 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();

const REF_NUM="AJ001";

form.append('USERNAME', sessionStorage.getItem("USERNAME"));
form.append('WPT_APP_ID', 11001);
form.append('REF_NUM', REF_NUM);
form.append('MPE_SCANS', "123");

//let formfiles={foto:false,sign:false,scans:false};


const file1 = selectedFiles[0].file;
let newFile=new File([file1], 'EXPORT_BFADM_DAY22.DMP');;

//requires a multipart form with a filename header
form.append('filename', newFile.name);
//form.append('MPE_SCANS', filenames.scans);

if (newFile==null){
	window.alert("abort for newFile is null");
	return;
	}//end if
else
	{
	form.append('filesupload', newFile);
	}

/*
const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
  headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      "Access-Control-Allow-Origin": "*",
	  "Accept-Encoding": "gzip, deflate, br"
  }
filesupload
*/


const request_config = {
	    headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': newFile.type
    },
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};


await axios.post(scansurl+'rarfileuploadbar/uploadfile', form, request_config)
.then(res => afteruploadfiles(res.data))
.catch(error => { 
		
         
     });//end catch





	
}//end func


function afteruploadfiles(data){
	console.log('afteruploadfiles: '+JSON.stringify(data));
	
	
}//end func



function selectedFilesChange(event){


let temp=selectedFiles;
temp.push({
	file:event.target.files[0]
	});
setSelectedFiles(temp);

}//end func

  return (
    <>
	
<table align="center" style={{"marginTop":"100px"}} >
<tbody>
<tr>
	<td align="right" >File Path:</td>
	<td align="left" ><input type="text" id="filepath" size="40" readOnly className="gnsbro" defaultValue={fileinput.path} onFocus={(e)=>{e.target.select();}} /></td>
</tr>
<tr>
	<td align="right" >File Input:</td>
	<td align="left" ><input type="file" onChange={(e)=>{selectedFilesChange(e);}}  /></td>
</tr>
<tr>
	<td align="right" >&nbsp;</td>
	<td align="left" ><button className="button"  onClick={(e)=>{uploadfiles(e);}} >upload file</button></td>
</tr>
<tr>
	<td align="right" >&nbsp;</td>
	<td align="left"  >
		<div id="progresspiechart"><p id="percentage" >Pie Test</p></div>
	</td>
</tr>

</tbody>
</table>

    </>
  );
  


};


export default RenderFileUploadBar;